const VALID_CARE_TYPES = new Set(['babysitter', 'nanny', 'pet_care', 'housekeeping', 'companion_care']);

const normalizeCareType = (value?: string | null): string | null => {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;

  const snakeCase = trimmed
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/-/g, '_')
    .toLowerCase();

  if (VALID_CARE_TYPES.has(snakeCase)) {
    return snakeCase;
  }

  return null;
};

const getProviderProfileUrl = (
  sitterId?: string | null,
  careType?: string | null,
  providerType?: string | null
): string | null => {
  if (!sitterId) return null;

  const normalizedCareType = normalizeCareType(careType) || normalizeCareType(providerType);
  if (!normalizedCareType) return null;

  return `/provider/profile/${normalizedCareType}/${sitterId}`;
};

export default getProviderProfileUrl;
